import { render, staticRenderFns } from "./HeZuoLianMengZhan2.vue?vue&type=template&id=40710e3b&scoped=true&"
import script from "./HeZuoLianMengZhan2.vue?vue&type=script&lang=js&"
export * from "./HeZuoLianMengZhan2.vue?vue&type=script&lang=js&"
import style0 from "./HeZuoLianMengZhan2.vue?vue&type=style&index=0&id=40710e3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40710e3b",
  null
  
)

export default component.exports